import {
  INIT_URL,
  ACCESS_TOKEN,
  SIGNOUT_USER_SUCCESS,
  USER,
  NEW_USER,
  IMPERSONATE

} from "constants/ActionTypes";

const INIT_STATE = {
  token: localStorage.getItem('token'),
  initURL: '/',
  authUser:'',
  newUser:'',
  impersonateFlag:false
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ACCESS_TOKEN: {
      return {
        ...state,
        token: action.payload,
      };
    }
    case USER: {
      return {
        ...state,
        authUser: action.payload,
      };
    }
    case NEW_USER: {
      return {
        ...state,
        newUser: action.payload,
      };
    }
    case IMPERSONATE: {
      return {
        ...state,
        impersonateFlag: action.payload,
      };
    }
    case INIT_URL: {
      return {...state, initURL: action.payload};
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        refreshToken: null,
        initURL: ''
      }
    }
    default:
      return state;
  }
}
